// Vendored from spynejs/application-shell src/index.js — the ROUTES slot (double-brace
// token below) receives the generated config.channels.ROUTE object. Refresh alongside
// shell.tar.gz if the shell's index.js evolves (vendor-shell.mjs prints the source commit).

// inject styles
import './scss/app.scss';

// load spyne
import { SpyneApp, ChannelFetch, SpyneAppProperties } from 'spyne';

// channels
import { ChannelApp } from 'channels/channel-app.js';
import { ChannelLocalStorage } from 'channels/channel-local-storage.js';
import { ChannelDeck } from 'channels/channel-deck.js';
import { ChannelFullscreen } from 'channels/channel-fullscreen.js';
import { ChannelSlideshow } from 'channels/channel-slideshow.js';
//plugins

//data fetch
import AppModelURL from 'data/app.model.json';
import DeckSchemaURL from 'data/deck-schema.json';

// initial view
import { AppContainer } from './app/app-container.js';

import pageItemTemplateLookup from 'traits/utils/page-item-template-lookup.js';

const config = {
  debug: true,
  storageConfig: {
    storageKey: 'spyneAppStorage',
    analyticsOptions: {},
    theme: 'dark',
    themeDefaults: {
      colorScheme: 'dark',
      enableTransitions: true,
    },
  },

  channels: {
    WINDOW: {
      mediaQueries: {
        showMenuDrawer: `(min-width: 1024px)`,
      },
      events: [
        'click',
        'mouseover',
        'mouseenter',
        'message',
        'keyup',
        'keydown',
        'fullscreenchange',
      ],
      customEvents: [{ name: 'spyne_cms_item_connected', buffer: 400 }],

      listenForScroll: true,
      listenForOrientation: true,
      debounceMSTimeForScroll: 50,
    },

    ROUTE: {
        // Query routing ignores the URL path, so the deck resolves at whatever
        // sub-path it is served from (relevantcontext.io/spynejs/deck/).
        "type": "query",
        "add404s": true,
        "routes": {
            "routePath": {
                "routeName": "pageId",
                "deck": ""
            }
        }
    },
  },

  // Theme judgment made at generation (see themes.json in the generator) —
  // edit theme_id / font_pairing_id and re-run the pipeline to re-theme.
  theme: {"theme_id":"blue-vivid","font_pairing_id":"spacegrotesk-inter"},
};

SpyneApp.init(config);

SpyneAppProperties.setProp('pageItemTemplateLookup', pageItemTemplateLookup);

// Staged deck content (isStagedContent: true) is built but held dark behind
// this one boolean — flip it to true to ship after partner sign-off.
SpyneAppProperties.setProp('deckShowStagedContent', false);
SpyneApp.registerChannel(new ChannelApp());
SpyneApp.registerChannel(new ChannelLocalStorage());
SpyneApp.registerChannel(new ChannelDeck());
SpyneApp.registerChannel(new ChannelFullscreen());
SpyneApp.registerChannel(new ChannelSlideshow());

const registerCmsChannels = () => {
  const mapFn = SpyneApp.pluginsFn.mapCmsData || ((d) => d);

  SpyneApp.registerChannel(
    new ChannelFetch('CHANNEL_FETCH_MODEL', {
      url: AppModelURL,
      map: mapFn,
    }),
  );

  SpyneApp.registerChannel(
    new ChannelFetch('CHANNEL_FETCH_DECK', {
      url: DeckSchemaURL,
      map: mapFn,
    }),
  );
};

/**
 * Dev tools (CMS plugin + channels console) load in development only, and can
 * be switched off there with SPYNE_DEV_TOOLS=off — the mode to verify in. The
 * CMS puts the body into a split layout that halves the content column, and
 * dev-tools.js gates channel registration behind a requestAnimationFrame that
 * hidden or background tabs throttle, so the app boots late or not at all.
 */

const devToolsEnabled =
  process.env.NODE_ENV === 'development' && SPYNE_DEV_TOOLS !== 'off';

if (devToolsEnabled) {
  import('./dev-tools.js').then(({ devToolsReady }) => {
    devToolsReady.then(registerCmsChannels);
  });
} else {
  // production, or development with SPYNE_DEV_TOOLS=off: no CMS, no delay
  registerCmsChannels();
}

new AppContainer().prependToDom(document.querySelector('body'));
